export const colors = {
  black: '#000000',
  white: '#FFFFFF',
  primary: '#004E2B',
  secondary: '#00843d',
  highlight: '#00dd39',
  hover: 'rgb(0,199,50)',
  background: '#e6e6df',
  grey: '#707070',
  red: '#FF644E'
};